import WIDGETS from './widgets';

export default {
	name: 'kind_sidebar_left_patient',
	sx: {
		height: '100%',
		flexWrap: 'nowrap',
	},
	spacing: 0,
	direction: 'column',
	className: 'exclude_from_sidebar',
	widgets: [
		{ content: WIDGETS.SIDE_BAR_LEFT_HEADER, breakpoints: { xs: 12 }, lazy_loading: 0, sx: { backgroundColor: '#1E233D', color: 'white' } },
		{
			content: WIDGETS.SIDE_BAR_LEFT_OVERVIEW_PATIENT,
			breakpoints: { xs: 12 },
			lazy_loading: 0,
			sx: { overflow: 'auto', flexGrow: 1, backgroundColor: '#232948', color: 'white' },
		},
		{ content: WIDGETS.SIDE_BAR_LEFT_USER, breakpoints: { xs: 12 }, lazy_loading: 0, sx: { backgroundColor: '#1E233D', color: 'white' } },
	],
};
